package com.example.mystybag.notificationsUtils.expected

actual object PushProviderHelper {
    actual fun setupPlatformHelper() {}
    actual suspend fun getToken(): Pair<String, Int> = "" to 0
    actual suspend fun checkDeviceRootedOrGetIntegrityToken(): Pair<String, Boolean> = "" to false
    actual fun getPushProvider(): Int = 0
}
